export default __webpack_public_path__ + "images/0495b023e20e7178adf60c27b1fddcab-font-awesome-paper-plane.svg";